import m from "../../geodata/es2015/icelandHigh";
window.am4geodata_icelandHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/icelandHigh.js
// module id = null
// module chunks = 